<template>
  <svg
    class="card-brand"
    :width="width"
    :height="height"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="32" rx="4" fill="white" />
    <g clip-path="url(#clip0_10096_3777)">
      <path
        d="M28.222 9.65869H19.7805V23.3389H28.222V9.65869Z"
        fill="#FF5F00"
      />
      <path
        d="M20.6499 16.5002C20.6489 15.1829 20.9498 13.8827 21.53 12.6978C22.1102 11.513 22.9544 10.4746 23.9987 9.66131C22.7053 8.65269 21.1519 8.02549 19.5162 7.85139C17.8805 7.67729 16.2284 7.96332 14.7487 8.67678C13.2691 9.39025 12.0216 10.5024 11.1488 11.886C10.2761 13.2697 9.81323 14.8691 9.81323 16.5014C9.81323 18.1337 10.2761 19.7331 11.1488 21.1168C12.0216 22.5005 13.2691 23.6126 14.7487 24.326C16.2284 25.0395 17.8805 25.3255 19.5162 25.1514C21.1519 24.9773 22.7053 24.3501 23.9987 23.3415C22.9541 22.528 22.1097 21.4892 21.5295 20.3039C20.9493 19.1186 20.6485 17.8179 20.6499 16.5002Z"
        fill="#EB001B"
      />
      <path
        d="M37.3477 21.8915V21.6112H37.4695V21.5532H37.1797V21.6112H37.2942V21.8915H37.3477ZM37.9103 21.8915V21.5532H37.8227L37.7204 21.7949L37.6181 21.5532H37.5304V21.8915H37.5937V21.6354L37.6887 21.8553H37.7545L37.8494 21.6354V21.8915H37.9103Z"
        fill="#F79E1B"
      />
      <path
        d="M38.1856 16.5002C38.1855 18.1327 37.7226 19.7321 36.8497 21.1159C35.9767 22.4996 34.729 23.6117 33.2492 24.325C31.7694 25.0384 30.1172 25.3243 28.4813 25.1499C26.8455 24.9756 25.2921 24.348 23.9988 23.3391C25.0427 22.5251 25.8867 21.4864 26.467 20.3015C27.0473 19.1166 27.3489 17.8164 27.3489 16.499C27.3489 15.1816 27.0473 13.8814 26.467 12.6965C25.8867 11.5116 25.0427 10.4729 23.9988 9.6589C25.2921 8.64996 26.8455 8.02245 28.4813 7.8481C30.1172 7.67376 31.7694 7.9596 33.2492 8.67297C34.729 9.38633 35.9767 10.4984 36.8497 11.8821C37.7226 13.2659 38.1855 14.8654 38.1856 16.4978V16.5002Z"
        fill="#F79E1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_10096_3777">
        <rect width="32" height="21" fill="white" transform="translate(8 6)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: Number,
    required: false,
    default: 48
  },
  height: {
    type: Number,
    required: false,
    default: 32
  }
})
</script>

<style lang="scss" scoped>
.card-brand {
  display: flex;
  border: solid 1px $gray-2;
  border-radius: 4px;
  box-sizing: border-box;
}
</style>
